var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{clip-path:url(#clippath);}.cls-4,.cls-5{fill:#689f63;}.cls-6{clip-path:url(#clippath-1);}.cls-7{clip-path:url(#clippath-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:#333;}.cls-10,.cls-5{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.47,33.69l-9.43,5.44c-.35.2-.57.58-.57.99v10.89c0,.41.22.78.57.99l9.43,5.45c.35.2.79.2,1.14,0l9.43-5.45c.35-.2.57-.58.57-.99v-10.89c0-.41-.22-.78-.57-.99l-9.43-5.44c-.18-.1-.37-.15-.57-.15s-.39.05-.57.15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -842.05,
    y1: 105.71,
    x2: -841.78,
    y2: 105.71,
    gradientTransform: "translate(-53637.45 81849.12) rotate(116.11) scale(115.31 -115.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5aad45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.7,51.7c.09.12.2.22.34.29l8.09,4.67,1.35.77c.2.12.43.17.66.15.08,0,.15-.02.22-.04l9.94-18.21c-.08-.08-.17-.15-.26-.21l-6.17-3.57-3.26-1.88c-.09-.05-.19-.09-.3-.12l-10.6,18.13Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -835.66,
    y1: 99.29,
    x2: -835.49,
    y2: 99.29,
    gradientTransform: "translate(129477.39 -73735.37) rotate(-36.46) scale(177.06 -177.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76ac64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.92,33.54c-.16.02-.31.06-.46.15l-9.4,5.43,10.14,18.47c.14-.02.28-.07.41-.14l9.43-5.45c.29-.17.49-.45.55-.78l-10.33-17.66c-.08-.01-.15-.02-.23-.02-.03,0-.06,0-.09,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -833.51,
    y1: 101.84,
    x2: -833.35,
    y2: 101.84,
    gradientTransform: "translate(108290.7 13273.98) scale(129.89 -129.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79b461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75ac64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3e863d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m49.43,80.32c-.33,0-.65-.09-.94-.25l-2.98-1.77c-.45-.25-.23-.34-.08-.39.59-.21.72-.26,1.35-.62.07-.04.15-.02.22.02l2.29,1.36c.08.04.2.04.28,0l8.94-5.16c.08-.05.14-.14.14-.24v-10.32c0-.1-.05-.19-.14-.25l-8.94-5.16c-.08-.05-.19-.05-.28,0l-8.94,5.16c-.09.05-.14.15-.14.24v10.32c0,.1.05.19.14.24l2.45,1.41c1.33.66,2.14-.12,2.14-.91v-10.18c0-.15.11-.26.26-.26h1.13c.14,0,.26.11.26.26v10.19c0,1.77-.97,2.79-2.65,2.79-.52,0-.92,0-2.06-.56l-2.35-1.35c-.58-.34-.94-.96-.94-1.63v-10.32c0-.67.36-1.3.94-1.63l8.95-5.16c.57-.32,1.32-.32,1.88,0l8.94,5.17c.58.33.94.96.94,1.63v10.32c0,.67-.36,1.29-.94,1.63l-8.94,5.16c-.29.17-.61.25-.94.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.19,73.21c-3.91,0-4.73-1.8-4.73-3.3,0-.14.12-.26.26-.26h1.15c.13,0,.23.09.26.22.17,1.18.69,1.77,3.06,1.77,1.88,0,2.69-.43,2.69-1.42,0-.58-.23-1-3.16-1.29-2.45-.24-3.96-.78-3.96-2.74,0-1.8,1.52-2.88,4.07-2.88,2.86,0,4.28.99,4.46,3.13,0,.07-.02.15-.07.2-.05.05-.12.08-.19.08h-1.16c-.12,0-.23-.09-.25-.2-.28-1.24-.96-1.63-2.79-1.63-2.06,0-2.3.72-2.3,1.25,0,.65.28.84,3.06,1.21,2.75.36,4.05.88,4.05,2.81s-1.62,3.06-4.46,3.06m10.89-10.94h.3c.25,0,.29-.17.29-.27,0-.26-.18-.26-.28-.26h-.31v.54Zm-.37-.85h.66c.23,0,.68,0,.68.51,0,.36-.23.43-.36.47.27.02.28.19.32.44.02.15.05.42.1.51h-.41c-.01-.09-.07-.58-.07-.61-.03-.11-.06-.16-.2-.16h-.34v.77h-.37v-1.94Zm-.8.96c0,.8.65,1.45,1.44,1.45s1.45-.66,1.45-1.45-.66-1.44-1.45-1.44-1.44.63-1.44,1.44m3.17,0c0,.95-.78,1.72-1.72,1.72s-1.72-.77-1.72-1.72.8-1.72,1.72-1.72,1.72.75,1.72,1.72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m21.75,39.95c0-.41-.22-.79-.57-.99l-9.48-5.45c-.16-.09-.34-.14-.52-.15h-.1c-.18,0-.36.06-.52.15l-9.48,5.45c-.35.21-.57.58-.57,1l.02,14.69c0,.2.11.39.28.49.17.11.39.11.57,0l5.64-3.23c.36-.21.57-.59.57-.99v-6.86c0-.41.22-.79.57-.99l2.4-1.38c.18-.1.37-.15.57-.15s.4.05.57.15l2.4,1.38c.35.2.57.58.57.99v6.86c0,.41.22.78.57.99l5.63,3.22c.18.11.4.11.57,0,.17-.1.28-.29.28-.49l.02-14.69Zm44.73,7.65c0,.1-.05.2-.14.25l-3.26,1.88c-.09.05-.2.05-.29,0l-3.26-1.88c-.09-.05-.14-.15-.14-.25v-3.76c0-.1.05-.2.14-.25l3.25-1.88c.09-.05.2-.05.29,0l3.26,1.88c.09.05.14.15.14.25v3.76Zm.88-27.84c-.18-.1-.39-.1-.57,0-.17.1-.28.29-.28.49v14.55c0,.14-.08.28-.2.35-.12.07-.28.07-.4,0l-2.37-1.37c-.35-.2-.79-.2-1.14,0l-9.48,5.47c-.35.2-.57.58-.57.99v10.95c0,.41.22.79.57.99l9.48,5.48c.35.2.79.2,1.15,0l9.48-5.48c.35-.21.57-.58.57-.99v-27.29c0-.42-.23-.8-.59-1l-5.64-3.15Zm31.58,23.98c.35-.2.57-.58.57-.99v-2.65c0-.41-.22-.78-.57-.99l-9.42-5.47c-.36-.21-.79-.21-1.15,0l-9.48,5.47c-.36.21-.57.58-.57.99v10.94c0,.41.22.79.58,1l9.42,5.37c.35.2.77.2,1.12,0l5.7-3.17c.18-.1.29-.29.29-.5s-.11-.4-.29-.5l-9.54-5.47c-.18-.1-.29-.29-.29-.49v-3.43c0-.2.11-.39.29-.5l2.97-1.71c.18-.1.39-.1.57,0l2.97,1.71c.18.1.29.29.29.49v2.7c0,.2.11.39.29.5.18.1.4.1.57,0l5.69-3.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m88.8,43.23c.07-.04.15-.04.22,0l1.82,1.05c.07.04.11.11.11.19v2.1c0,.08-.04.15-.11.19l-1.82,1.05c-.07.04-.15.04-.22,0l-1.82-1.05c-.07-.04-.11-.11-.11-.19v-2.1c0-.08.04-.15.11-.19l1.82-1.05Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m57.13,38.21l-26.57-13.02-13.62,27.79,26.57,13.02,13.62-27.79Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m15.22,42.06l18.76,25.39,24.81-18.33-18.76-25.39-24.81,18.33Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m27.07,33.54v24.04h20.52v-24.04h-20.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/node-js.18ea845ca7e1d123e78a2a5025d6434c.svg";
export { ForwardRef as ReactComponent };